import axios from "axios";
const baserUrl =
  "https://cors-anywhere.herokuapp.com/http://18.211.207.245:3000";
const env = {
  prod: process.env.REACT_APP_PAYMENT_PROD_API,
  dev: process.env.REACT_APP_PAYMENT_DEV_API
};
const orgEnv = {
  prod: process.env.REACT_APP_BASEURL_PROD_API,
  dev: process.env.REACT_APP_BASEURL_DEV_API
};
let currentEnv;
if (
  window.location.host.includes("amazon") ||
  window.location.host.includes("localhost") ||
  window.location.host.includes("shapla")
) {
  currentEnv = "dev";
} else {
  currentEnv = "prod";
}
const orgBaseUrl = orgEnv[currentEnv];

export function getDonors(id,token) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${orgBaseUrl}/organizations/${id}/donations`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getDonationsDashboard(id, days ,token) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${orgBaseUrl}/organizations/${id}/donationsDashboard?days=${days}`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getDonorsCardData(id, days ,token) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${orgBaseUrl}/organizations/${id}/donationsCardData?days=${days}`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getDonationsByCategory(id ,token) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${orgBaseUrl}/organizations/${id}/donationsbycategory`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getInvitedDonorsData(id, token) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${orgBaseUrl}/organizations/${id}/getInviteDonors`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}